<ng-container>
    <ntap-prime-common-itemview #itemView></ntap-prime-common-itemview>
    <ng-container *ngIf="itemView.activeTab === 0">
      <!-- <app-jedinica-gradiva-predaja-lista></app-jedinica-gradiva-predaja-lista> -->
    </ng-container>
  </ng-container>